import {useEffect, useState} from 'react';
import {ReactComponent as ArrowUpIcon} from './arrow-up-small.svg';
import theme from '../../view/theme.module.scss';

export default function ReportingScrollToTop() {
    const [visible, setVisible] = useState(() => window.scrollY >= 50);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY >= 50);
        window.addEventListener('scroll', onScroll, {passive: true});
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    if (!visible) return null;

    return <button type="button" className={theme.scrollToTop} aria-label="Back to top"
        onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}>
        <ArrowUpIcon aria-hidden="true"/>
    </button>;
}
